module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-1-blue.svg";